import React, { useState } from 'react';
import Img from '../Img';

export default function CollapseMenu(props) {
    const [toggled, setToggled] = useState(true);

    return (
        <div className="c_13">
            <div className="c_13_1" onClick={() => setToggled(!toggled)}>
                <span className="c_13_1_1">{props.title}</span>
                <div className="c_13_1_2">
                    <span className="c_13_1_2_1">{props.info}</span>
                    <Img className="c_13_1_2_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate={toggled ? '180' : ''} />
                </div>
            </div>
            {toggled &&
                <div className="c_13_2">
                    {props.children}
                </div>
            }
        </div>
    );
}
